var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      ref: "scroller",
      staticClass: "scroller",
      nativeOn: {
        scroll: function ($event) {
          return _vm.onScroll($event)
        },
      },
    },
    _vm._l(_vm.value, function (message) {
      return _c("app-chat-message", {
        key: message.id,
        ref: "messages",
        refInFor: true,
        attrs: { value: message },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }